import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-view-event-modal',
  templateUrl: './view-event-modal.component.html',
  styleUrls: ['./view-event-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ViewEventModalComponent {

}
